
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaRecord as ObiMediaRecordElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-record.js';
 
 
 

 
 export const ObiMediaRecord = createComponent({
   react: React,
   tagName: 'obi-media-record',
   elementClass: ObiMediaRecordElement,
   events: {
     
   }
  });
 
 